import dayjs from 'dayjs';

export const InitialCarFormValidations = {
  pickup: null,
  dropoff: null,
  pickupDateTime: null,
  returnDateTime: null,
};

const validateCarSearchInputs = (
  setFormValidations,
  leadDays,
  searchInputs,
  doShowValidationErrors = true,
) => {
  const validationObj = { ...InitialCarFormValidations };
  const reasons = [];
  if (!searchInputs.pickupCode) reasons.push('pickupMissing');
  if (!searchInputs.dropoffCode) reasons.push('dropoffMissing');
  if (!searchInputs.pickupDateTime) reasons.push('pickupDateTimeMissing');
  if (!searchInputs.returnDateTime) reasons.push('returnDateTimeMissing');
  validationObj.pickup = searchInputs.pickupCode ? null : 'Pick up port is required';
  validationObj.dropoff = searchInputs.dropoffCode ? null : 'Drop-off port is required';
  validationObj.pickupDateTime = searchInputs.pickupDateTime ? null : 'Pickup date is required';
  validationObj.returnDateTime = searchInputs.returnDateTime ? null : 'Drop-off date is required';
  const minCheckInDate = dayjs().startOf('day').add(leadDays, 'day');
  if (dayjs(searchInputs.pickupDateTime).isBefore(minCheckInDate)) {
    validationObj.pickupDateTime = `Pickup date cannot be earlier than ${leadDays} ${leadDays === 1 ? 'day' : 'days'} from today.`;
    reasons.push('pickupBeforeLeadDays');
  }
  if (doShowValidationErrors) setFormValidations(validationObj);
  return { isValid: reasons.length === 0, reasons };
};

export default validateCarSearchInputs;
